import { Table, TableBody, TableCell, TableRow } from '@mui/material'
import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getAtomicLogs, getAtomicTransfers } from '../helpers/Api'
import { AssetTransactionItem } from './AssetTransactionItem'
import { UxAccordion } from '../uxitems/uxaccordion/UxAccordion'

export const AssetTransactions = ({ assetId }) => {
    const transactions = []

    const [logs, setLogs] = useState([])

    const [transfers, setTransfers] = useState([])

    for (const log of logs) {
        transactions.push(log)
    }

    for (const transfer of transfers) {
        transactions.push(transfer)
    }

    const { t } = useTranslation('common')

    const parseTransfers = (res) => {
        if (res && res['success']) {
            setTransfers(res['data'])
        }
    }

    const parseLogs = (res) => {
        if (res && res['success']) {
            setLogs(res['data'])
        }
    }

    useEffect(() => {
        if (assetId) {
            getAtomicTransfers(assetId).then(parseTransfers)
            getAtomicLogs(assetId).then(parseLogs)
        }
    }, [assetId])

    return (
        <div
            className={cn(
                'border dark:!bg-paper bg-white rounded-md shadow-xl',
                'dark:!border-paperl border-zinc-200 p-4 ml-0 lg:ml-4 mt-4 w-auto',
            )}
        >
            <UxAccordion
                title={t('asset.transactions')}
                itemKey="TransactionsAccordion"
                defaultExpandedKeys={[]}
            >
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell>{t('asset.date')}</TableCell>
                            <TableCell>{t('search.type')}</TableCell>
                            <TableCell>{t('asset.transaction_id')}</TableCell>
                            <TableCell>{t('asset.sender')}</TableCell>
                            <TableCell></TableCell>
                            <TableCell>{t('asset.receiver')}</TableCell>
                        </TableRow>
                        {transactions
                            ? transactions
                                  .sort(
                                      (a, b) =>
                                          parseInt(
                                              a.transfer_id
                                                  ? a.transfer_id
                                                  : a.log_id,
                                          ) -
                                          parseInt(
                                              b.transfer_id
                                                  ? b.transfer_id
                                                  : b.log_id,
                                          ),
                                  )
                                  .map((transaction) => (
                                      <AssetTransactionItem
                                          transaction={transaction}
                                      />
                                  ))
                            : ''}
                    </TableBody>
                </Table>
            </UxAccordion>
        </div>
    )
}
